/**
 * Direction enum.
 * @enum {number}
 * @description The direction of the list.
 * @property {number} HORIZONTAL - The horizontal direction.
 * @property {number} VERTICAL - The vertical direction.
 */
enum Direction {
  HORIZONTAL,
  VERTICAL,
}

/**
 * Arrow direction enum.
 * @enum {number}
 * @description The direction of the arrow.
 * @property {number} LEFT - The left direction.
 * @property {number} RIGHT - The right direction.
 * @property {number} UP - The up direction.
 * @property {number} DOWN - The down direction.
 */
enum ArrowDirection {
  LEFT,
  RIGHT,
  UP,
  DOWN,
}

export { ArrowDirection };
export default Direction;
